import axiosInstance from "./AxiosInstance";

export const get_infos = async () => {
    const company_id = parseInt(localStorage.getItem("company_id"));
    let data = await axiosInstance.get(`/company/`);
    return data.data
    
}

